<template>
  <div v-if="this.fileDatas" class="exclude_close_overlays">
    <div class="d-flex flex-start">
      <input type="file" multiple id="btnAddFile" @change="handleFileChange" hidden />
      <label for="btnAddFile">
        <span class="btn btn-xs btn-secondary">
          <i class="bi bi-plus"></i>파일추가
        </span>
      </label>
      <span class="btn btn-xs btn-secondary ms-2" :class="{'disabled': this.fileDatas.length == 0}" @click="removeFileAll()">
        <i class="bi bi-trash"></i>전체삭제
      </span>
    </div>
    <div class="fileupload mt-2" @dragover.prevent="handleDragOver" @drop.prevent="handleDrop" :style="{'height': this.height}">
      <div v-if="this.fileDatas.length == 0" class="d-flex justify-content-center align-items-center h-100 text-muted">
        Add files by Drag & Drop
      </div>
      <ul v-else class="area_file list-unstyled p-1">        
        <li v-for="(file, index) in this.fileDatas" :key="index">
          <i class="file_remove bi bi-x link fw-bolder fs-4" :title="$t('삭제')" @click.stop="removeFile(index, file.fileId)"></i>
          <span class="file_name ms-1 text-truncate flex-grow-1" :title="file.name || file.filename">{{ file.name || file.filename }}</span>
          <span class='file_size ms-2 text-muted fs-8'>{{ file.size.f('file_size') }}</span>
        </li>
      </ul>
    </div>
  </div>
  <div v-else>Error</div>
</template>
  
<script>
export default {
  props: {
    files: [],
    deleteFileIds: [],
    height: { default: () => '64px' },
  },
  data() {
    return {
      fileDatas: this.files,
      deleteFileIdDatas: this.deleteFileIds,
    };
  },
  methods: {
    handleDragOver(event) {
      event.dataTransfer.dropEffect = "copy";
    },
    handleDrop(event) {
      const files = Array.from(event.dataTransfer.files);
      this.addFiles(files);
    },
    handleFileChange(event) {
      const files = Array.from(event.target.files);
      this.addFiles(files);
      event.target.value = '';
    },
    addFiles(addFiles) {
      let addedFiles = addFiles.filter(addFile => {
        let newFlag = true;
        for(const file of this.fileDatas) {
          if(file.name == addFile.name && file.size == addFile.size) {
            newFlag = false;
            break;
          }
        }
        return newFlag;
      });
      this.fileDatas.push(...addedFiles);
      
      if(addFiles.length != addedFiles.length) {
        if(addedFiles.length == 0) {
          this.$bvToast.toast('파일이 중복됩니다.', { headerClass: 'd-none', variant: 'warning', toaster: 'b-toaster-bottom-right', autoHideDelay: 3000 });
        } else {
          this.$bvToast.toast('중복되는 파일을 제거했습니다.', { headerClass: 'd-none', variant: 'warning', toaster: 'b-toaster-bottom-right', autoHideDelay: 3000 });
        }
      }
    },
    removeFile(index, fileId) {
      if(fileId) this.deleteFileIdDatas.push(fileId);
      this.fileDatas.splice(index, 1);
    },
    removeFileAll() {
      this.fileDatas.forEach(item => {
        if(item.fileId) {
          this.deleteFileIdDatas.push(item.fileId);
        }
      });
      this.fileDatas = [];
    },
  },
};
</script>
  
<style>
.fileupload {
  overflow-y: auto;
  border: 1px solid var(--bs-gray-400);
  border-radius: 4px;
}

.area_file > li {
  display: flex;
  align-items: center;
  padding: 2px 2px;
}

.area_file > li > * {
  text-align: left;
}
</style>
  